import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import {
    MaterialCategoryBody,
    MaterialCategoryDetails,
    MaterialCategoryListItem,
} from "types/api/materialCategory";

function useMaterialCategoryApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllMaterialCategory = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<MaterialCategoryListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<MaterialCategoryListItem>>({
            url: "/material-category",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneMaterialCategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<MaterialCategoryDetails> => {
        return get<PathParamsWithId, undefined, MaterialCategoryDetails>({
            url: "/material-category/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createMaterialCategory = React.useCallback((body: MaterialCategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, MaterialCategoryBody, ResponseWithId>({
            url: "/material-category",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateMaterialCategory = React.useCallback((pathParams: PathParamsWithId, body: MaterialCategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, MaterialCategoryBody, null>({
            url: "/material-category/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteMaterialCategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/material-category/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllMaterialCategory,
        getOneMaterialCategory,
        createMaterialCategory,
        updateMaterialCategory,
        deleteMaterialCategory
    };
}

export default useMaterialCategoryApi;